import { render } from "./stockGroup.vue?vue&type=template&id=adeeb6c0&scoped=true"
import script from "./stockGroup.vue?vue&type=script&lang=ts"
export * from "./stockGroup.vue?vue&type=script&lang=ts"

import "./stockGroup.vue?vue&type=style&index=0&id=adeeb6c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-adeeb6c0"

export default script